import script from "./ModuleTable.vue?vue&type=script&setup=true&lang=ts"
export * from "./ModuleTable.vue?vue&type=script&setup=true&lang=ts"

import "./ModuleTable.vue?vue&type=style&index=0&id=3179abd0&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3179abd0"]])

export default __exports__